import CustomCard from "components/CustomCard";
import ToolSnippet from "components/ToolSnippet";
import useAuthentication from "hooks/useAuthentication";
import { tools } from "consts/tools";

const relatedTools = tools.filter((t) =>
  [
    "quiddity-northbound-monitor",
    "quiddity-southbound-monitor",
    "quiddity-a-h-shares-monitor",
  ].includes(t.id)
);

const QuiddityToolsWidget = () => {
  const { account: loggedInAccount } = useAuthentication();

  if (!loggedInAccount?.canViewQuiddityTools) return null;

  return (
    <CustomCard className="p-[15px]">
      <h3 className="text-[16px] font-medium">Related Tools</h3>
      <div className="space-y-[15px]">
        {relatedTools.map((tool) => (
          <ToolSnippet
            tool={tool}
            key={tool.id}
            className="bg-none shadow-none !px-0 hover:bg-transparent hover:text-smart-teal"
            iconClassName="min-w-[35px] min-h-[35px]"
            titleClassName="text-[15px]"
            badgeClassName="text-[8px]"
            hideDescription
            linkTarget="_blank"
          />
        ))}
      </div>
    </CustomCard>
  );
};

export default QuiddityToolsWidget;
